import { render, staticRenderFns } from "./subAddIssueClarificationNotice.vue?vue&type=template&id=ea5079aa&scoped=true"
import script from "./subAddIssueClarificationNotice.vue?vue&type=script&lang=js"
export * from "./subAddIssueClarificationNotice.vue?vue&type=script&lang=js"
import style0 from "./subAddIssueClarificationNotice.vue?vue&type=style&index=0&id=ea5079aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea5079aa",
  null
  
)

export default component.exports